// Fixed timezone for the app: Argentina (UTC-3, no DST).
// Using a fixed offset avoids "moving day" bugs caused by misconfigured
// device clocks or browsers that report UTC.
const AR_OFFSET_MS = -3 * 60 * 60 * 1000;

export type ArDateParts = {
  year: number;
  month: number; // 0-indexed
  day: number;
  hours: number;
  minutes: number;
};

// Returns wall-clock date parts as they appear in Argentina.
export function getArDateParts(date: Date = new Date()): ArDateParts {
  // Shift so the UTC parts of the shifted Date equal the AR wall clock.
  const shifted = new Date(date.getTime() + AR_OFFSET_MS);
  return {
    year: shifted.getUTCFullYear(),
    month: shifted.getUTCMonth(),
    day: shifted.getUTCDate(),
    hours: shifted.getUTCHours(),
    minutes: shifted.getUTCMinutes(),
  };
}

export function getArDateKey(date: Date | string = new Date()): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const p = getArDateParts(d);
  return `${p.year}-${String(p.month + 1).padStart(2, "0")}-${String(p.day).padStart(2, "0")}`;
}

// Builds an ISO string representing 12:00 in Argentina on the given AR date.
// 12:00 AR == 15:00 UTC.
export function getArNoonIso(year: number, month: number, day: number): string {
  return new Date(Date.UTC(year, month, day, 15, 0, 0, 0)).toISOString();
}

// Returns a synthetic Date whose local getFullYear/getMonth/getDate match
// the current Argentina wall-clock day. Useful for code that expects a Date.
export function getArTodayAsLocalDate(): Date {
  const p = getArDateParts();
  return new Date(p.year, p.month, p.day, p.hours, p.minutes, 0, 0);
}